// patientAppState is a free-form JSON object on the backend (typealias PatientAppState = JsonObject).
// The legacy patient-app uses two fields inside it; we model them explicitly.
export type PatientAppStateApiDto = {
  profileFormFilled?: boolean
  bloodGlucoseDeviceSetupCompleted?: boolean
} | null

export type PatientAppState = {
  profileFormFilled: boolean
  bloodGlucoseDeviceSetupCompleted: boolean
}

export const toPatientAppState = (dto: PatientAppStateApiDto): PatientAppState => ({
  profileFormFilled: dto?.profileFormFilled ?? false,
  bloodGlucoseDeviceSetupCompleted: dto?.bloodGlucoseDeviceSetupCompleted ?? false,
})

// For writes: build the wire shape from the domain shape.
export const toPatientAppStateApiDto = (state: PatientAppState): PatientAppStateApiDto => ({
  profileFormFilled: state.profileFormFilled,
  bloodGlucoseDeviceSetupCompleted: state.bloodGlucoseDeviceSetupCompleted,
})
